var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",attrs:{"id":"app"}},[(_vm.showError)?_c('ErrorPage',{attrs:{"status":_vm.error.status}}):[_c('router-view'),_vm._v(" "),(_vm.showAgeGate)?_c('AgeGate'):_vm._e()],_vm._v(" "),(_vm.isMounted)?_c('WwToaster'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }